import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-geist\",\"display\":\"swap\"}],\"variableName\":\"geist\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ChunkReloadGuard"] */ "/vercel/path0/web/app/components/chunk-reload-guard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollReveal"] */ "/vercel/path0/web/app/components/scroll-reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipManager"] */ "/vercel/path0/web/app/components/tooltip-manager.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["MicrosoftClarity"] */ "/vercel/path0/web/app/microsoft-clarity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlausibleAnalytics"] */ "/vercel/path0/web/app/plausible-analytics.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/app/saas.css");
